import { render } from "./messages.vue?vue&type=template&id=79b272aa&scoped=true"
import script from "./messages.vue?vue&type=script&lang=js"
export * from "./messages.vue?vue&type=script&lang=js"

import "./messages.vue?vue&type=style&index=0&id=79b272aa&scoped=true&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/BreakOutTheBox/messages-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b272aa"]])

export default __exports__